import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import AdminPortal from './components/AdminPortal';
import { ToastProvider } from './components/ui/toast';

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<AdminPortal />} />
        </Routes>

        <ToastProvider />
    </Router>
  );
}

export default App;
